import { Container, Segment } from 'semantic-ui-react';

import React from 'react';

const currentYear = new Date().getFullYear();

const Footer = () => (
  <Segment inverted vertical textAlign='center'>
    <Container>
      <p>Created by DevTeam &copy; 2018-{currentYear}.</p>
    </Container>
  </Segment>
);

export default Footer;
